module.exports = __webpack_public_path__ + "static/media/o-donnell-o-neill-design.258d6058.png";